<button class="user-chip" type="button" nz-dropdown nzTrigger="click" nzPlacement="bottomRight" [nzDropdownMenu]="menu">
  <span class="user-chip__avatar">{{ initials() }}</span>
  <span class="user-chip__copy">
    <strong>{{ user()?.username }}</strong>
    @if (roleName()) { <small>{{ roleName() }}</small> }
  </span>
</button>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu class="user-menu-dropdown">
    @if (user()?.email) {
      <li nz-menu-item class="user-menu-info">
        <div class="user-menu-email">{{ user()?.email }}</div>
      </li>
      <li nz-menu-divider></li>
    }
    <li nz-menu-item routerLink="/status">
      <app-icon name="monitor_heart" [size]="18" />
      <span>Stato sistema</span>
    </li>
    <li nz-menu-item (click)="toggleTheme.emit()">
      <app-icon [name]="darkTheme() ? 'light_mode' : 'dark_mode'" [size]="18" />
      <span>{{ darkTheme() ? 'Tema chiaro' : 'Tema scuro' }}</span>
    </li>
  </ul>
</nz-dropdown-menu>
